/* eslint-disable no-unused-vars */
const popupWidth = 370;
const popupMinHeight = 16;
const popupOffset = 35;
const arrowWidth = 10;
const arrowOffset = 10;
export const getStyle = (_, { palette = {} }) => ({
  alertPopupContariner: {
    display: 'inline-block',
    marginLeft: '5px',
    position: 'relative',
  },
  alertIcon: {
    color: '#0078D4',
  },
  alertPopup: {
    boxShadow: '0px 3.2px 7.2px rgba(0, 0, 0, 0.132), 0px 0.6px 1.8px rgba(0, 0, 0, 0.108)',
    position: 'absolute',
    zIndex: 1000,
    '& .arrow': {
      display: 'block',
      background: '#fff',
      width: '10px',
      height: '10px',
      transform: 'rotate(45deg)',
      position: 'absolute',
      boxShadow: '0 6.4px 14.4px 0 rgba(0,0,0,.132), 0 1.2px 3.6px 0 rgba(0,0,0,.108)',
      zIndex: '-1',
    },
    '& .text': {
      position: 'relative',
      zIndex: 0,
      padding: '13px 16px',
      fontSize: '12px',
      lineHeight: '16px',
      width: `${popupWidth}px`,
      minHeight: `${popupMinHeight}px`,
      fontWeight: '400',
      color: '#323130',
      background: '#fff',
    },
    '&.bottom': {
      top: `${popupOffset}px`,
      left: `-${popupWidth / 2}px`,
      '& .arrow': {
        top: `-${arrowWidth / 2}px`,
        left: `${popupWidth / 2}px`,
      },
    },
    '&.top': {
      bottom: `${popupOffset}px`,
      left: `-${popupWidth / 2}px`,
      '& .arrow': {
        bottom: `-${arrowWidth / 2}px`,
        left: `${popupWidth / 2}px`,
      },
    },
    '&.right': {
      top: '0px',
      left: `${popupOffset}px`,
      '& .arrow': {
        top: `${arrowOffset}px`,
        left: `-${arrowWidth / 2}px`,
      },
    },
    '&.left': {
      top: '0px',
      right: `${popupOffset}px`,
      '& .arrow': {
        top: `${arrowOffset}px`,
        right: `-${arrowWidth / 2}px`,
      },
    },
  },
});
